/**
 * API Configuration Utility
 * Resolves the backend URL from env or derives from window.location.origin
 */

/**
 * Get the backend URL with validation
 * @returns {string} Backend URL
 */
export const getBackendURL = () => {
  const url = process.env.REACT_APP_BACKEND_URL;
  
  if (url) {
    return url;
  }

  // Production fallback: derive from current origin (frontend & backend share the same domain)
  if (typeof window !== 'undefined' && window.location && window.location.origin) {
    console.warn('REACT_APP_BACKEND_URL not set, using window.location.origin:', window.location.origin);
    return window.location.origin;
  }

  // Development-only fallback
  console.warn('REACT_APP_BACKEND_URL not set, using localhost fallback');
  return 'http://localhost:8001';
};

/**
 * Get the API base URL (backend URL + /api prefix)
 * @returns {string} API base URL
 */
export const getAPIURL = () => {
  const backendURL = getBackendURL();
  return `${backendURL}/api`;
};

// Export the URLs as constants for convenience
export const BACKEND_URL = getBackendURL();
export const API_URL = getAPIURL();

// Default export
export default {
  BACKEND_URL,
  API_URL,
  getBackendURL,
  getAPIURL
};
